import React from 'react';
import PropTypes from 'prop-types';

export default function PasskeyButton({
  type = 'button',
  className = '',
  'data-dd-action-name': dataDdActionName = '',
  onClick,
  disabled = false,
  isPasskeyLoading = false,
}) {
  return (
    <button
      type={type}
      className={className}
      data-dd-action-name={dataDdActionName}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="passkey-signin-button__content">
        <span className="passkey-signin-button__label">
          {isPasskeyLoading
            ? 'Signing in with passkey...'
            : 'Sign in with passkey'}
        </span>
        <img src="/img/FIDO_black.svg" alt="" />
      </span>
    </button>
  );
}

PasskeyButton.propTypes = {
  className: PropTypes.string,
  'data-dd-action-name': PropTypes.string,
  disabled: PropTypes.bool,
  isPasskeyLoading: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
};
